var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Vehicle Deviation")]),_c('hr'),_c('flexibleFilter',{attrs:{"dealer_filter":false,"item_filter":false,"simple_date":true,"fetch_filter":_vm.fetchFilter},on:{"onFilter":_vm.setFilterUrl}}),_c('div',{staticClass:"innerBox mt-5"},[_c('vehicle-deviation-table',{attrs:{"filterUrl":_vm.filterUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }